import { IPScrollablePane } from 'baseComponents';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackItemStylesPaddingSceneScroll, globalStackTokensGapSmall } from 'globalStyles';
import Tag from 'models/tag';
import Task from 'models/tasks/task';
import { TaskDetailAssignment } from './Details/TaskDetailAssignment';
import { TaskDetailDeadline } from './Details/TaskDetailDeadline';
import { TaskDetailDescription } from './Details/TaskDetailDecription';
import { TaskDetailExternalId } from './Details/TaskDetailExternalId';
import { TaskDetailName } from './Details/TaskDetailName';
import { TaskDetailRecurrence } from './Details/TaskDetailRecurrence';
import { TaskDetailStart } from './Details/TaskDetailStart';
import { TaskDetailStatus } from './Details/TaskDetailStatus';
import { TaskDetailStatusActive } from './Details/TaskDetailStatusActive';
import { TaskDetailTags } from './Details/TaskDetailTags';

interface IMonitoringTaskDetail {
  task: Task;
  orgTask: Task;
  canUpdate: boolean;
  compactView: boolean | undefined;
  isActionPending: boolean;
  tags: Tag[];
  masterTask?: Task;
  addTagToTaskState: (tag: Tag) => void;
  removeTagFromTaskState: (tag: Tag) => void;
  onChangeCompletionDate: (completionDate: Date) => void;
  getErrorMessage: (field: string) => string | undefined;
  onUpdate: (newTask: Task) => void;
}

export const MonitoringTaskDetail = (props: IMonitoringTaskDetail) => {
  //
  // Render helpers
  //
  const getTemplateStatusFields = () => {
    if (props.task.isSeries()) {
      return (
        <TaskDetailStatusActive
          orgTask={props.orgTask}
          task={props.task}
          canUpdate={props.canUpdate}
          onUpdate={props.onUpdate}
          checkOnly={false}
        />
      );
    } else {
      return (
        <TaskDetailStatus
          task={props.task}
          orgTask={props.orgTask}
          canUpdate={props.canUpdate}
          onUpdate={props.onUpdate}
          onChangeCompletionDate={props.onChangeCompletionDate}
          showCompleted={true}
        />
      );
    }
  };

  //
  // Main render
  //
  return (
    <IPStack verticalFill tokens={globalStackTokensGapSmall}>
      <IPStack.Item grow styles={globalStackItemStylesPaddingSceneScroll}>
        <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>
          <IPStack verticalFill tokens={globalStackTokensGapSmall} styles={{ root: { paddingRight: 10 } }}>
            <TaskDetailName
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              readonly={props.task.isInstance()}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
              compactView={props.compactView}
            />
            <TaskDetailTags
              orgTask={props.orgTask}
              task={props.task}
              tags={props.tags}
              canUpdate={props.canUpdate}
              addTagToTaskState={props.addTagToTaskState}
              removeTagFromTaskState={props.removeTagFromTaskState}
              isActionPending={props.isActionPending}
              fixedTagIds={props.masterTask?.tagIds}
            />
            <TaskDetailDescription
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
            <TaskDetailAssignment
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
            />
            {getTemplateStatusFields()}
            <TaskDetailStart
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
            />
            <TaskDetailDeadline
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
              getErrorMessage={props.getErrorMessage}
            />
            <TaskDetailRecurrence
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
            <TaskDetailExternalId
              orgTask={props.orgTask}
              task={props.task}
              canUpdate={props.canUpdate}
              onUpdate={props.onUpdate}
            />
          </IPStack>
        </IPScrollablePane>
      </IPStack.Item>
    </IPStack>
  );
};
